module.exports = __webpack_public_path__ + "img/11.e1221930.png";